import { Component, Input, ViewChild, ElementRef, Renderer } from '@angular/core';
 
  
@Component({
  selector: 'expandable-list',
  templateUrl: 'expandable-list.html'
})
export class ExpandableListComponent {
  
  @ViewChild('expandWrapper', {read: ElementRef}) expandWrapper;
    @Input('expanded') expanded;
    @Input('expandHeight') expandHeight;
 
    constructor(public renderer: Renderer) {
 
    }
 
    ngAfterViewInit(){
        this.renderer.setElementStyle(this.expandWrapper.nativeElement, 'height', this.expandHeight + 'px');   
    }
 
}



// WEBPACK FOOTER //
// ./src/components/expandable-list/expandable-list.ts